<template>
  <v-container>
    <btn-a class="ma-2" outlined rounded color="primary" @click="calendarProdDialogOpen">
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <v-list two-line subheader v-if="value.calendarProds">
      <div v-for="(item,i) in value.calendarProds" :key="i">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ dayOfWeeks[item.dayOfWeek].value }}</v-list-item-title>
            <v-list-item-subtitle>{{ `${item.start} / ${item.end}` }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click="calendarProdDialogOpen(item)">
              <v-icon color="warning">mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action>
            <v-btn icon @click="calendarProdRemove(item)">
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider v-if="value.calendarProds && value.calendarProds.length"></v-divider>
      </div>
    </v-list>
    <dialog-d
      ref="calendarProdDialog"
      title="Calendar Prod"
      @confirm="calendarProdConfirm"
      @cancel="calendarProdDialogCancel"
    >
      <calendarProdForm ref="form" v-model="calendarProdSelected" />
    </dialog-d>
  </v-container>
</template>


<script>
//import moment from 'moment'
import calendarProdForm from "../environments/calendarProdForm";
export default {
  components: { calendarProdForm },
  props: {
    value: {
      default: () => {
        return {
          description: "",
          calendarProd: [],
          jobStatus: [],
          calendarProds: [],
          calendarExcs: []
        };
      }
    }
  },
  data() {
    return {
      dayOfWeeks: [
 { key: 0, value: this.$t("dayOfWeek.sunday") },
        { key: 1, value: this.$t("dayOfWeek.monday") },
        { key: 2, value: this.$t("dayOfWeek.tuesday")  },
        { key: 3, value: this.$t("dayOfWeek.wednesday")  },
        { key: 4, value: this.$t("dayOfWeek.thursday")  },
        { key: 5, value: this.$t("dayOfWeek.friday")  },
        { key: 6, value: this.$t("dayOfWeek.saturday")  }
      ],
      calendarProdSelected: {},
      calendarProdSelectedRef: null
    };
  },
  computed: {
    calendarProdComp() {
      let calendarProd = [];
      this.value.calendarProds.forEach(js => {
        if (js.status != this.calendarProdSelected.status)
          calendarProd.push(js.status);
      });
      return calendarProd;
    }
  },
  methods: {
    calendarProdDialogCancel() {
      this.calendarProdSelectedRef = null;
    },
    calendarProdConfirm() {
      if(!this.$refs.form.isValid()) return;
      if (this.calendarProdSelectedRef != null) {
        Object.assign(this.calendarProdSelectedRef, this.calendarProdSelected);
      } else {
        this.value.calendarProds.push(this.calendarProdSelected);
      }
      this.$refs.calendarProdDialog.open();
      this.calendarProdSelectedRef = null;
    },
    calendarProdRemove(calendarProd) {
      let index = this.value.calendarProds.indexOf(calendarProd);
      if (index >= 0) this.value.calendarProds.splice(index, 1);
    },
    calendarProdDialogOpen(calendarProd) {
      if (calendarProd) {
        this.calendarProdSelectedRef = calendarProd;
        let obj = {};
        Object.assign(obj, calendarProd);
        this.calendarProdSelected = obj;
      } else {
        this.calendarProdSelected = {
           start : "",
           end: "",
           dayOfWeek:null
        };
      }

      this.$refs.calendarProdDialog.open();
    }
  }
};
</script>